import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { mergeMap, first } from 'rxjs/operators';
import { AuthService } from '../auth/auth.service';
import {
  HttpEvent,
  HttpRequest,
  HttpHandler,
  HttpInterceptor,
} from '@angular/common/http';

@Injectable()
export class RefreshTokenInterceptor implements HttpInterceptor {
  constructor(private authService: AuthService) {}
  intercept(
    httpRequest: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (
      // check if the token is valid and the incoming call is of not refresh token call
      // checking if it's not token call to avoid multiple token calls for each incmong request
      !httpRequest.url.includes('/token') && // DPD-2520 need to update this when token endpoint changes. also consider team and partner token url both.
      this.authService.hasValidAccessToken()
    ) {
      return this.authService.getAccessToken().pipe(
        first(),
        mergeMap((tokenResponse) => {
          // mutate the original request with the new/old token we received from refresh token call
          const mutatedRequest = httpRequest.clone({
            setHeaders: {
              authorization: `Bearer ${tokenResponse}`,
            },
          });

          // continue with the mutated request.
          return next.handle(mutatedRequest);
        })
      );
    } else {
      // continue the request without doing anything
      return next.handle(httpRequest);
    }
  }
}
